import React from 'react';
import { z } from 'zod';

import { StoreConnector, UiKit } from 'components';
import { useForm } from 'utils/hooks';
import { useConnectForm } from '../hooks';
import { STORE_URL_PREFIX, STORE_URL_SUFFIX } from '../stubs';

export const FORM_SCHEMA = z.object({
  storeUrl: z.string().min(1, 'Store URL is required')
});

export default function WoocommerceConnect() {
  const { isConnecting, connect } = useConnectForm();

  const { data, errors, isDirty, onChange, onValidate } = useForm({
    dataSchema: FORM_SCHEMA,
    defaultData: { storeUrl: '' }
  });

  const onSubmit = e => {
    e.preventDefault();

    const isValid = onValidate(data);
    if (!isValid) return;

    connect({
      shop: `${STORE_URL_PREFIX.WOOCOMMERCE}${data.storeUrl}${STORE_URL_SUFFIX.WOOCOMMERCE}`
    });
  };

  return (
    <form onSubmit={onSubmit}>
      <StoreConnector.UrlInput
        disablePreview
        name="storeUrl"
        value={data.storeUrl}
        onChange={value => onChange({ storeUrl: value })}
        label="Woo Store URL"
        placeholder="Enter your store URL"
        prefix={STORE_URL_PREFIX.WOOCOMMERCE}
        suffix={STORE_URL_SUFFIX.WOOCOMMERCE}
        error={errors.storeUrl}
      />
      <UiKit.Button
        disabled={!isDirty}
        processing={isConnecting}
        className="w-100"
      >
        Connect your WooCommerce Store
      </UiKit.Button>
    </form>
  );
}
